module.exports = __webpack_public_path__ + "img/409.03ff4e44.jpg";